import React, { useEffect, useRef, useState } from "react";
import "./careerValue.css";
import { getCareerDiversity } from "../Service/CareerApi";
import { API_BASE_IMG_URl } from "helper/environment";
import TypedText from "components/Homes/typewrite";

const DIVERSITY_UUID = "9eec3b98-ac3d-449c-827a-b5db5e8bb6d7";

export default function CareerTeamDetail() {
  const [node, setNode] = useState<any>(null);
  const [included, setIncluded] = useState<any[]>([]);

  useEffect(() => {
    getCareerDiversity(DIVERSITY_UUID)
      .then((res) => {
        setNode(res.data);
        setIncluded(res.included || []);
      })
      .catch(console.error);
  }, []);

  if (!node) return null;

  const getImageFromMedia = (mediaId?: string) => {
    if (!mediaId) return { url: null, alt: null };

    const media = included?.find(
      (inc: any) =>
        (inc.type === "media--image" || inc.type === "media--svg_image") &&
        inc.id === mediaId,
    );

    if (!media) return { url: null, alt: null };

    // handle both image and svg relationship fields
    const imageField =
      media.relationships?.field_media_image?.data ||
      media.relationships?.field_media_svg_image?.data;

    if (!imageField?.id) return { url: null, alt: null };

    const file = included?.find(
      (inc: any) => inc.type === "file--file" && inc.id === imageField.id,
    );

    const fileUrl = file?.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;

    const altText = imageField?.meta?.alt || media?.attributes?.name || "";

    return {
      url: fileUrl,
      alt: altText,
    };
  };
  const featureImages = node.relationships.field_image?.data || [];

  // ---------------- COUNTERS ----------------

  const cards = node.relationships.field_diversity_counter_data?.data || [];
  // ---------------- WOW DELAYS ----------------
  
//console.log(node);
  return (
    <div id="section-careercoreval" className="corporate-values-wrapper font-sans">
   
    
      {/* SECTION 2: LEADERSHIP QUOTE (White Bottom Pane) */}
      <section className="leadership-spotlight position-relative overflow-hidden career-section ">
        {/* Dynamic Abstract Blueprint Layout Wireframe Accents */}
       <div className='career-team-detail-top-background' />
        <div className="container mb-3 mb-md-3 mb-lg-5">
          <div className="row gx-2">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div
                className="section-title  text-center mx-auto mb-4 wow fadeInUp clearfix"
                data-wow-delay="0.1s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
              >
                <h6 className="text-white">{node?.attributes?.field_subtitle || ""}</h6>
                <h2 className="mb-4 text-white">
                  {node?.attributes?.title}
                   {/* <TypedText
                    index={1}
                    text={`<span  style="color: #000"> ${node?.attributes?.field_maintitle}</span> <span class='text-primary'>${node?.attributes?.field_title}</span>`}
                    delay={100}
                    cursor="|"
                  /> */}
                </h2>
              </div>
            </div>{" "}
          </div>
          {/* Profile Spotlight Grid Panel Frame */}
          <div className="row  mt-4 career-team-card">
            <div
              className="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 wow fadeInUp career-detail-img"
              data-wow-delay="0.3s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
            >
               {/* {featureImages.map((img: any, index: number) => {
                  const image = getImageFromMedia(img.id);

                  return (
                      <img
                 key={img.id}
                      src={image?.url || ""}
                      alt={image?.alt || "Integrity Ethics Honesty Respect"}
                loading="lazy"
                className="img-fluid rounded-4"
              />
                   
                  );
                })} */}
            {featureImages?.[0] && (
                <img
                  key={featureImages[0].id}
                  src={getImageFromMedia(featureImages[0].id)?.url || ""}
                  alt={getImageFromMedia(featureImages[0].id)?.alt || "Integrity Ethics Honesty Respect"}
                  loading="lazy"
                  className="img-fluid  rounded-4"
                />
              )}
            </div>
            <div
              className=" col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 wow fadeInUp career-detail-info"
              data-wow-delay="0.3s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
            >
              <div className="ps-lg-5 pe-lg-5 text-white mt-3">
                <img src="assets/img/career/quote-mark.webp" alt="quote-mark" width={40} className="img-fluid mb-3 mt-3 mt-md-0 mt-lg-0" />
                <i className="fa fa-quote-left fa-3x text-primary mb-3 mt-3 mt-md-0 mt-lg-0 d-none"></i>
                 <div
                  dangerouslySetInnerHTML={{
                    __html: node?.attributes?.field_content?.value || "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='career-team-detail-bottom-background' />
      </section>
    </div>
  );
}
